<form class="row form form-horizontal wordcloud-languages">
    <div class="text-end mt-1">
        <label class="control-label pe-2" for="languages"><small>{{ 'analytics.wordcloud_language' | translate}} </small></label>
        <mat-form-field id="languages">
            <mat-select [formControl]="languageCtrl" panelClass="" >
                <mat-select-trigger>
                    {{ (selected_language + "_lang") | translate}}
                </mat-select-trigger>
                @for(language of languages; track language){
                    <mat-option [value]="language">{{ language + "_lang" | translate}}</mat-option>
                }
            </mat-select>
        </mat-form-field>
    </div>
</form>

<highcharts-chart [constructorType]="chartConstructor"
                  [options]="(chartOptions$ | async)!"
                  [oneToOne]="true"
                  style="width: 100%; display: block;"></highcharts-chart>


<div class="wordcloud-filter">
    <div class="wordcloud-filter-items">
        @for(filter of moodFilters; track filter.mood){
            <span (click)="select(filter)" 
                  [ngClass]="{activeMoodFilter: filter.active}">
                <i class="icon-smileys-{{filter.mood}}" [ngStyle]="{color: filter.active ? filter.color : '#cccccc'}"></i><span>{{filter.mood | translate}}</span>
            </span>
        }
    </div>
</div>